// extracted by mini-css-extract-plugin
export default {"wrapper":"localmultiplayerintroduction_wrapper__v9q-z","button":"localmultiplayerintroduction_button__xSsay"};